import { render, staticRenderFns } from "./tpl-2.vue?vue&type=template&id=4f1b5916&scoped=true"
import script from "./tpl-2.vue?vue&type=script&lang=js"
export * from "./tpl-2.vue?vue&type=script&lang=js"
import style0 from "./tpl-2.vue?vue&type=style&index=0&id=4f1b5916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b5916",
  null
  
)

export default component.exports